/** "Compramos tu carta": the page to offer cards to the store and the person's requests. */
export const buyEs = {
  "nav.buy": "Compramos tu carta",
  "nav.buyShort": "Te compramos",
  "buy.fromSell": "¿Preferís no publicar y vendérselas directo a la tienda?",
  "buy.metaTitle": "Compramos tu carta",
  "buy.title": "Compramos tus cartas Pokémon",
  "buy.intro": "¿Tenés cartas o productos sellados de Pokémon que ya no usás? Contanos cuáles son, mandanos fotos y te decimos cuánto te pagamos.",
  "buy.step1": "Elegí tus cartas",
  "buy.step1Text": "Buscalas en nuestro catálogo (o escribilas si no aparecen) y decinos en qué estado están.",
  "buy.step2": "Mandanos fotos",
  "buy.step2Text": "De frente y de dorso, con buena luz, para ver el estado.",
  "buy.step3": "Te pasamos una oferta",
  "buy.step3Text": "Te avisamos por email cuánto te pagamos. Si te sirve, la aceptás y coordinamos.",
  "buy.terms": "La oferta está sujeta a revisar las cartas en mano: te pagamos cuando las vemos. Si no coinciden con las fotos (otro estado, o no son originales), podemos cambiar la oferta o no comprarlas. Si las mandás por correo, el envío corre por tu cuenta.",
  "buy.otherMarket": "¿Preferís venderlas vos a otros fans? Publicalas en el mercado de la comunidad.",
  "buy.login": "Ingresá para ofrecernos tus cartas",
  "buy.cards": "Tus cartas",
  "buy.findCard": "Buscá la carta o el producto",
  "buy.notFound": "¿No la encontrás? Escribila",
  "buy.notFoundPlaceholder": "Ej.: Charizard 4/102 Base Set",
  "buy.add": "Agregar",
  "buy.noCards": "Todavía no agregaste cartas.",
  "buy.condition": "Estado",
  "buy.language": "Idioma",
  "buy.quantity": "Cantidad",
  "buy.itemNote": "Nota (opcional)",
  "buy.remove": "Quitar",
  "buy.photos": "Fotos",
  "buy.photosHint": "Entre 1 y {max} fotos (JPG, PNG o WebP).",
  "buy.photosChosen": "{count} fotos elegidas",
  "buy.photosChosen_one": "1 foto elegida",
  "buy.handover": "¿Cómo te las compramos?",
  "buy.handover.meet": "Nos encontramos",
  "buy.handover.meetHint": "En CABA o GBA, en un lugar público.",
  "buy.handover.store": "Las traigo al punto de retiro",
  "buy.handover.storeHint": "Te pasamos la dirección y el horario.",
  "buy.handover.ship": "Las mando por correo",
  "buy.handover.shipHint": "Desde cualquier lugar del país (el envío corre por tu cuenta).",
  "buy.zone": "Zona",
  "buy.location": "Barrio o localidad",
  "buy.locationShip": "Ciudad y provincia",
  "buy.availability": "¿Cuándo podés? (opcional)",
  "buy.availabilityPlaceholder": "Ej.: tardes de semana, sábados a la mañana",
  "buy.phone": "Teléfono / WhatsApp",
  "buy.payout": "¿Cómo querés cobrar?",
  "buy.payout.transfer": "Transferencia",
  "buy.payout.cash": "Efectivo",
  "buy.birthDate": "Fecha de nacimiento",
  "buy.birthDateHint": "Solo compramos a mayores de 18 años.",
  "buy.birthDateMinor": "Para vendernos cartas tenés que tener 18 años o más.",
  "buy.notes": "¿Algo más que tengamos que saber? (opcional)",
  "buy.pokemonOnly": "Son cartas o productos de Pokémon (solo compramos Pokémon).",
  "buy.send": "Enviar",
  "buy.sending": "Enviando…",
  "buy.errorItems": "Agregá al menos una carta.",
  "buy.errorPhotos": "Agregá al menos una foto.",
  "buy.errorFields": "Revisá los datos marcados.",
  "buy.errorTooMany": "Ya tenés {max} ofertas abiertas: esperá nuestra respuesta o cancelá alguna.",
  "buy.errorPhotoUpload": "No pudimos subir las fotos. Probá de nuevo desde Mis cartas ofrecidas.",
  "buy.blocked": "No podemos aceptar esta oferta. Si creés que es un error, escribinos.",
  "buy.mine": "Mis cartas ofrecidas",
  "buy.mineHint": "Las cartas que nos ofreciste y nuestras ofertas.",
  "buy.mineEmpty": "Todavía no nos ofreciste cartas.",
  "buy.offerNew": "Ofrecer cartas",
  "buy.status.draft": "Sin enviar",
  "buy.status.pending": "La estamos revisando",
  "buy.status.quoted": "Tenés una oferta",
  "buy.status.accepted": "Aceptada: coordinamos",
  "buy.status.rejected": "Rechazaste la oferta",
  "buy.status.declined": "No la compramos",
  "buy.status.cancelled": "Cancelada",
  "buy.status.completed": "Comprada",
  "buy.draftHint": "Falta enviarla: agregá al menos una foto y tocá Enviar.",
  "buy.offer": "Te ofrecemos {amount}",
  "buy.offerTerms": "Sujeta a revisar las cartas en mano.",
  "buy.accept": "Aceptar la oferta",
  "buy.reject": "Rechazar",
  "buy.cancel": "Cancelar",
  "buy.cancelConfirm": "¿Cancelar esta oferta de cartas?",
  "buy.accountTitle": "¿A qué cuenta te transferimos?",
  "buy.holder": "Titular",
  "buy.accountError": "Completá el titular y un CBU/CVU (22 números) o alias.",
  "buy.acceptedHint": "¡Genial! Te vamos a escribir al {phone} para coordinar.",
  "buy.reason": "Motivo: {reason}",
  "buy.addPhotos": "Agregar fotos",
  "buy.itemsCount": "{count} cartas",
  "buy.itemsCount_one": "1 carta",
  "buy.sentOn": "Enviada el {date}",
} as const;

export const buyEn: Record<keyof typeof buyEs, string> = {
  "nav.buy": "We buy your cards",
  "nav.buyShort": "We buy",
  "buy.fromSell": "Rather not list them and sell them straight to the store?",
  "buy.metaTitle": "We buy your cards",
  "buy.title": "We buy your Pokémon cards",
  "buy.intro": "Got Pokémon cards or sealed products you don't use anymore? Tell us which ones, send us photos and we'll tell you how much we pay.",
  "buy.step1": "Pick your cards",
  "buy.step1Text": "Find them in our catalog (or type them if they aren't there) and tell us their condition.",
  "buy.step2": "Send us photos",
  "buy.step2Text": "Front and back, in good light, so we can see the condition.",
  "buy.step3": "We send you an offer",
  "buy.step3Text": "We email you how much we pay. If it works for you, accept it and we arrange the rest.",
  "buy.terms": "The offer depends on checking the cards in hand: we pay when we see them. If they don't match the photos (another condition, or not genuine), we may change the offer or not buy them. If you ship them, shipping is on you.",
  "buy.otherMarket": "Rather sell them yourself to other fans? List them in the community market.",
  "buy.login": "Sign in to offer us your cards",
  "buy.cards": "Your cards",
  "buy.findCard": "Find the card or product",
  "buy.notFound": "Can't find it? Type it",
  "buy.notFoundPlaceholder": "E.g.: Charizard 4/102 Base Set",
  "buy.add": "Add",
  "buy.noCards": "You haven't added any cards yet.",
  "buy.condition": "Condition",
  "buy.language": "Language",
  "buy.quantity": "Quantity",
  "buy.itemNote": "Note (optional)",
  "buy.remove": "Remove",
  "buy.photos": "Photos",
  "buy.photosHint": "1 to {max} photos (JPG, PNG or WebP).",
  "buy.photosChosen": "{count} photos chosen",
  "buy.photosChosen_one": "1 photo chosen",
  "buy.handover": "How do we buy them?",
  "buy.handover.meet": "We meet",
  "buy.handover.meetHint": "In CABA or GBA, in a public place.",
  "buy.handover.store": "I bring them to the pickup point",
  "buy.handover.storeHint": "We send you the address and hours.",
  "buy.handover.ship": "I ship them",
  "buy.handover.shipHint": "From anywhere in the country (shipping is on you).",
  "buy.zone": "Area",
  "buy.location": "Neighbourhood or town",
  "buy.locationShip": "City and province",
  "buy.availability": "When are you free? (optional)",
  "buy.availabilityPlaceholder": "E.g.: weekday afternoons, Saturday mornings",
  "buy.phone": "Phone / WhatsApp",
  "buy.payout": "How do you want to get paid?",
  "buy.payout.transfer": "Bank transfer",
  "buy.payout.cash": "Cash",
  "buy.birthDate": "Date of birth",
  "buy.birthDateHint": "We only buy from people 18 or older.",
  "buy.birthDateMinor": "You must be 18 or older to sell us cards.",
  "buy.notes": "Anything else we should know? (optional)",
  "buy.pokemonOnly": "They are Pokémon cards or products (we only buy Pokémon).",
  "buy.send": "Send",
  "buy.sending": "Sending…",
  "buy.errorItems": "Add at least one card.",
  "buy.errorPhotos": "Add at least one photo.",
  "buy.errorFields": "Check the highlighted fields.",
  "buy.errorTooMany": "You already have {max} open offers: wait for our answer or cancel one.",
  "buy.errorPhotoUpload": "We couldn't upload the photos. Try again from My offered cards.",
  "buy.blocked": "We can't accept this offer. If you think it's a mistake, write to us.",
  "buy.mine": "My offered cards",
  "buy.mineHint": "The cards you offered us and our offers.",
  "buy.mineEmpty": "You haven't offered us any cards yet.",
  "buy.offerNew": "Offer cards",
  "buy.status.draft": "Not sent",
  "buy.status.pending": "We're reviewing it",
  "buy.status.quoted": "You have an offer",
  "buy.status.accepted": "Accepted: let's arrange it",
  "buy.status.rejected": "You rejected the offer",
  "buy.status.declined": "We're not buying it",
  "buy.status.cancelled": "Cancelled",
  "buy.status.completed": "Bought",
  "buy.draftHint": "Not sent yet: add at least one photo and tap Send.",
  "buy.offer": "We offer you {amount}",
  "buy.offerTerms": "Subject to checking the cards in hand.",
  "buy.accept": "Accept the offer",
  "buy.reject": "Reject",
  "buy.cancel": "Cancel",
  "buy.cancelConfirm": "Cancel this card offer?",
  "buy.accountTitle": "Which account do we transfer to?",
  "buy.holder": "Account holder",
  "buy.accountError": "Fill in the holder and a CBU/CVU (22 digits) or alias.",
  "buy.acceptedHint": "Great! We'll message you at {phone} to arrange it.",
  "buy.reason": "Reason: {reason}",
  "buy.addPhotos": "Add photos",
  "buy.itemsCount": "{count} cards",
  "buy.itemsCount_one": "1 card",
  "buy.sentOn": "Sent on {date}",
};
